import client from './client';

export const getHomePreview = () => client.get('/operations/home-preview');

export const getDiscoveryPreview = () => client.get('/operations/discovery-preview');
